<template>
  <div class="signUp">
    <welcome-image/>
    <MainPreloader
        v-if="signUpStore.loading"
        position="fixed"
        :size="80"
        :stroke="3"
    />
    <section class="signUp__right">
      <form class="signUp__form">
        <div class="signUp__line">
          <h2 class="signUp__title">Создать кибераккаунт</h2>
        </div>

        <div class="signUp__line">
          <label class="signUp__textLabel">Придумайте пароль</label>
          <form-input  v-model="signUpStore.password"  :type="showPassword ? 'text':'password' "/>
        </div>

        <div class="signUp__line">
          <label class="signUp__textLabel">Повторите пароль</label>
          <form-input  v-model="signUpStore.confirmPassword"  :type="showPassword ? 'text':'password' "/>
          <div class="signUp__options">
            <CheckBox
                style="color: var(--cd-text-muted)"
                text="Показать пароль"
                v-model="showPassword"
            ></CheckBox>
          </div>
        </div>

        <div class="signUp__line">
            <ActionButton
                style="width: 225px"
                icon-type="arrow"
                @button-click="signUpHandler"
                :disabled="signUpStore.loading"
            >
              <template #caption>Зарегистрироваться</template>
            </ActionButton>
        </div>
        <div class="signUp__line">
          <span class="signUp__noAccount">
             Есть аккаунт? &nbsp;
              <router-link class="signUp__link"  :to="{name: 'SignInView'}" >Войти</router-link>
          </span>
        </div>
      </form>
    </section>

  </div>
</template>

<script>
import CheckBox from "@/components/ui/CheckBox.vue";
import ActionButton from "@/components/ui/ActionButton.vue";
import {ref} from "vue";
import FormInput from "@/components/ui/FormInput.vue";
import WelcomeImage from "@/components/shared/WelcomeImage.vue";
import {useSignUpStore} from "@/store/signup";
import {useRouter} from "vue-router";
import {useToast} from "vue-toast-notification";
import MainPreloader from "@/components/shared/MainPreloader.vue";

export default {
  name: "SignUpStep2View",
  components: {MainPreloader, WelcomeImage, FormInput, ActionButton, CheckBox},
  setup() {
    const signUpStore = useSignUpStore();
    const showPassword = ref(false)
    const router = useRouter();
    const toast = useToast();
    async function signUpHandler() {
      if (signUpStore.loading) {
        toast.error('Ожидайте завершения операции')
        return;

      }
      if(signUpStore.password !== signUpStore.confirmPassword) {
        toast.error('Пароли не совпадают')
        return;
      }
      if(signUpStore.password.length < 12) {
        toast.error('Пароль должен содержать 12 или более символов')
        return
      }
      if(!signUpStore.userName) {
        toast.error('Не задано имя пользователя')
        return
      }
      await signUpStore.signUp(signUpStore.userName, signUpStore.password)
      if(signUpStore.error) {
        toast.error(signUpStore.error);
        return;
      }
      await router.push({name: 'SignUpFinishView'});
    }
    return {
      showPassword,
      signUpStore,
      signUpHandler
    }
  }
}
</script>


<style scoped lang="scss">
@use "./SignUpView.scss";
</style>
